module.exports = __webpack_public_path__ + "img/icon2.fb17c46e.png";